// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_3R8B5","dangerous":"view-default_dangerous_1NbR-"};